<template>
  <div class="homeContainer">
    <div class="contant">
      <div class="top">
        <div class="form">
          <div class="form-row">
            <div class="row-item">
              <span>服务单号</span>
              <el-input v-model="form.orderNo" placeholder="请输入服务单号"></el-input>
            </div>
            <div class="row-item">
              <span>申请号</span>
              <el-input v-model="form.applyNo" placeholder="请输入申请号"></el-input>
            </div>
            <div class="row-item">
              <span>申请人</span>
              <el-input v-model="form.applyPerson" placeholder="请输入申请人姓名"></el-input>
            </div>
            <div class="row-item">
              <span>状态</span>
              <el-select placeholder="请选择" v-model="form.orderStatus">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  style="height:30px;font-size:12px;font-family:MicrosoftYaHei;line-height:30px;"
                ></el-option>
              </el-select>
            </div>
            <div class="row-item">
              <span>更新时间</span>
              <el-date-picker
                v-model="form.formTime"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="changeDate"
                value-format="yyyy-MM-dd"
                style="width:75%;height:30px;float:left;min-width:225px;"
                :clearable ='false'
              ></el-date-picker>
            </div>
          </div>
          <div class="form-row">
            <div class="row-item">
              <span class="search" @click="search">查询</span>
              <span class="reset" @click="reset">重置</span>
            </div>
          </div>
        </div>
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          :header-cell-style="tableClass"
          :default-sort="{prop: 'date', order: 'descending'}"
          border
        >
          <el-table-column prop="orderNo" label="服务单号" width="180"></el-table-column>
          <el-table-column prop="askforId" label="申请号" width="100"></el-table-column>
          <el-table-column label="类别" width="80">
            <template slot-scope="scope">
              <span>第{{scope.row.tradeType||'--'}}类</span>
            </template>
          </el-table-column>
          <el-table-column label="商标图样">
            <template slot-scope="scope">
              <img :src="scope.row.tradeImg" alt style="width:100%;height:100%;" />
            </template>
          </el-table-column>
          <el-table-column prop="applicantName" label="申请人"></el-table-column>
          <el-table-column prop="deliveryStatusName" label="状态"></el-table-column>
          <el-table-column prop="deliveryUpdated" label="更新时间" sortable></el-table-column>
          <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="goDetail(scope.row.orderNo)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <b>共{{total}}条</b>
          <div>
            <!-- <span class="demonstration">调整每页显示条数</span> -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="10"
              layout="prev, pager, next"
              :total="total"
              style="display:inline-block;"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReOrderList, getOrderDetails } from "@/api/fill.js";
export default {
  data() {
    return {
      loading: true,
      // 总数据条数
      total: 0,
      // 表单数据
      form: {
        // 表单数据中服务单号数据
        orderNo: "",
        // 表单数据中申请号数据
        applyNo: "",
        // 表单数据中申请人数据
        applyPerson: "",
        // 表单数据中状态数据
        orderStatus: "",
        // 表单数据中的更新时间数据
        formTime: "",
        // 表单数据中开始时间
        startTime: "",
        // 表单数据中结束时间
        endTime: "",
      },
      // 表单数据中下拉框选项
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "待完善材料",
          label: "待完善材料",
        },
        {
          value: "顾问收集材料中",
          label: "顾问收集材料中",
        },
        {
          value: "申请递交中",
          label: "申请递交中",
        },
        {
          value: "通知书已下发",
          label: "通知书已下发",
        },
        {
          value: "补充材料递交中",
          label: "补充材料递交中",
        },
        {
          value: "初审公告",
          label: "初审公告",
        },
        {
          value: "服务完成",
          label: "服务完成",
        },
        {
          value: "服务关闭",
          label: "服务关闭",
        },
      ],
      // 表格数据
      tableData: [],
      formInline: {
        user: "",
        region: "",
      },
      multipleSelection: [],
      // 当前页
      currentPage: 1,
      // 每页展示数据条数
      pageSize: 10,
      // loading标识符
      loading: true,
    };
  },
  computed: {
    // 修改表头背景色
    tableClass() {
      return { background: "rgba(247,252,255,1)", border: "none" };
    },
  },
  methods: {
    // 跳转到详情页
    goDetail(orderNo) {
      let params = {
        orderNo,
      };
      this.loading = true;
      getOrderDetails(params).then((res) => {
        if (res.status == 0) {
          this.loading = false;
          if (res.data.channelItemCode == "zzsbfs") {
            // 自助版
            this.$router.push(`detailpay?orderNo=${orderNo}`);
          } else if (res.data.channelItemCode == "zysbfs") {
            // 专业版
            this.$router.push(`spdetail?orderNo=${orderNo}`);
          }
        } else {
          this.$message.error("数据请求失败！");
        }
      });
    },
    // 请求驳回复审表格数据
    getTableDate(
      orderNo, //单号(空)
      askforId, //申请码(空)
      applicantName, //申请人(空)
      status, // N 订单状态(空)
      pageIndex, // Y 当前页(空)
      pageSize, // Y 每页大小(空)
      startTime, // N 开始时间(空)
      entTime // N 结束时间(空)
    ) {
      let params = {
        orderNo, //单号
        askforId, //申请码
        applicantName, //申请人
        status, // N 订单状态
        pageIndex: pageIndex || 1, // Y 当前页{
        pageSize: this.pageSize || 10, // Y 每页大小，最大为50
        startTime, // N 开始时间
        entTime, // N 结束时间
      };
      this.loading = true;
      getReOrderList(params).then((res) => {
        if (res.status === 0) {
          this.loading = false;
          this.tableData = res.data.map((item, index) => {
            if (item.deliveryUpdated) {
              item.deliveryUpdated = this.formatTime(item.deliveryUpdated);
            } else {
              item.deliveryUpdated = this.formatTime(item.updated_at);
            }
            return item;
          });
          this.total = res.dataCount;
          // console.log(this.tableData);
        } else if(res.status === -99){
          this.$message.error("用户信息失效，请重新登录");
        }else{
          this.$message.error("数据请求失败");
        }
      });
    },
    // 查询数据
    search() {
      // 校验输入信息是否全为空
      let emptyNum = 0;
      for (let key in this.form) {
        if (this.form[key] == "") {
          emptyNum++;
        }
      }
      // 如果全为空，则不请求
      if (emptyNum == 7) {
        this.$message.error("请输入有效信息！");
      } else {
        this.currentPage = 1;
        if (this.form.orderStatus === "全部") {
          this.form.orderStatus = "";
        }
        this.getTableDate(
          this.form.orderNo, //查询单号
          this.form.applyNo, //查询申请号
          this.form.applyPerson, //查询申请人
          this.form.orderStatus, //查询订单状态
          this.currentPage, //当前页(1)
          this.pageSize, //每页大小
          this.form.startTime, //开始(更新)时间
          this.form.endTime //结束时间()
        );
      }
    },
    // 重置查询数据
    reset() {
      this.form.orderNo = "";
      this.form.applyNo = "";
      this.form.applyPerson = "";
      this.form.orderStatus = "";
      this.form.formTime = "";
      this.form.startTime = "";
      this.form.endTime = "";
      this.getTableDate()
    },
    // 格式时间
    formatTime(timeStr) {
      let time = "--";
      if (timeStr) {
        if (timeStr.indexOf("T") !== -1) {
          let tmpStr = timeStr.split("T");
          let tmpYMD = tmpStr[0];
          let tmpHMS = tmpStr[1].split(".")[0];
          time = tmpYMD + " " + tmpHMS;
        } else {
          time = timeStr;
        }
      }
      return time;
    },
    // 监听时间输入框数据变化
    changeDate(e) {
      // 格式时间
      if(e){
        this.form.startTime = e[0]
        this.form.endTime = e[1]
      }
      
    },
    // 切换表格选中状态
    // toggleSelection(rows) {
    //   if (rows) {
    //     rows.forEach(row => {
    //       this.$refs.multipleTable.toggleRowSelection(row);
    //     });
    //   } else {
    //     this.$refs.multipleTable.clearSelection();
    //   }
    // },
    // 监听表格每一行的选中状态
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      // console.log("当前页变了", this.currentPage);
      this.getTableDate(
        this.form.orderNo, //查询单号
        this.form.applyNo, //查询申请号
        this.form.applyPerson, //查询申请人
        this.form.orderStatus, //查询订单状态
        val, //当前页
        this.pageSize, //每页大小
        this.form.startTime, //开始(更新)时间
        this.form.endTime //结束时间()
      );
    },
    // 切换每页展示数据条数
    handleSizeChange(pageSize) {
      // console.log("每页展示条数变了", pageSize);
      this.pageSize = pageSize;
      this.getTableDate(
        this.form.orderNo, //查询单号
        this.form.applyNo, //查询申请号
        this.form.applyPerson, //查询申请人
        this.form.orderStatus, //查询订单状态
        1, //当前页
        this.pageSize, //每页大小
        this.form.startTime, //开始(更新)时间
        this.form.endTime //结束时间(null)
      );
    },
  },

  beforeRouteEnter(to, from, next) {
    // 路由导航钩子，此时还不能获取组件实例 `this`，所以无法在data中定义变量（利用vm除外）
    // 所以，利用路由元信息中的meta字段设置变量，方便在各个位置获取。这就是为什么在meta中定义isBack
    if (from.name == "detailpay" || from.name == "spdetail") {
      to.meta.isBack = true;
      //判断是从哪个路由过来的，
      //如果是detailpay或者spdetail过来的，表明当前页面不需要刷新获取新数据，直接用之前缓存的数据即可
    }
    next();
  },

  activated() {
    if (!this.$route.meta.isBack) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // console.log("数据更新了");
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
  },
  mounted() {
    // console.log("mounted周期执行了", this.$router);
    this.getTableDate();
  },
};
</script>

<style lang = 'scss' scoped>
.homeContainer {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .contant {
    padding: 20px;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    .top {
      width: 98%;
      box-sizing: border-box;
      overflow: hidden;
      position: absolute;
      top: 20px;
      bottom: 13px;
      left: 50%;
      transform: translateX(-50%);
      .block {
        margin: 0;
        height: 67px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        background-color: #fff;
        align-items: center;
        padding-left: 14px;
        position: absolute;
        bottom: 3px;
        border-top: 1px solid rgba(229, 229, 229, 1);
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
        div {
          span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(136, 136, 136, 1);
            line-height: 17px;
            display: inline-block;
          }
        }
      }
      .form {
        width: 100%;
        padding-bottom: 20px;
        position: absolute;
        top: 0;
        border-spacing: 20px;
        border-collapse: separate;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
        .form-row {
          width: 100%;
          display: flex;
          margin-top: 20px;
          justify-content: flex-start;
          .row-item {
            display: flex;
            flex-wrap: nowrap;
            float: left;
            width: 18%;
            justify-content: space-evenly;
            /deep/.el-date-editor {
              .el-input__inner {
                padding-left: 30px !important;
              }
              .el-input__icon {
                line-height: 24px;
                margin-left: -10px;
              }
              .el-range-separator {
                line-height: 24px;
                width: 10%;
              }
              .el-input__prefix {
                top: -5px;
              }
            }
            .el-select {
              width: 70%;
            }

            /deep/.el-input__inner {
              border-radius: 0px;
              width: 100%;
              height: 30px;
              padding-left: 10px;
            }
            /deep/.el-input__icon {
              &.el-icon-time {
                display: none;
              }
            }
            /deep/.el-input__suffix {
              .el-select__caret {
                line-height: 30px;
              }
              .el-input__suffix-inner {
                .el-icon-circle-close {
                  height: 30px;
                  line-height: 30px;
                }
              }
            }
            span {
              display: inline-block;
              padding: 0 5px;
              height: 30px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(136, 136, 136, 1);
              line-height: 30px;
              overflow: hidden;
              white-space: nowrap;
            }
            .search {
              height: 30px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              text-align: center;
              line-height: 30px;
              width: 75px;
              background: rgba(0, 110, 255, 1);
            }
            .search:hover {
              cursor: pointer;
            }
            .reset {
              width: 75px;
              height: 30px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 1);
              text-align: center;
              line-height: 30px;
              margin-right: 20px;
              border: 1px solid rgba(221, 221, 221, 1);
            }
            .reset:hover {
              cursor: pointer;
            }
            select {
              width: 60%;
              height: 30px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(221, 221, 221, 1);
              font-size: 12px;
              font-family: MicrosoftYaHei;
              color: rgba(0, 0, 0, 1);
              line-height: 16px;
              text-indent: 6px;
              .select-item {
                height: 30px;
                width: 100%;
                line-height: 30px;
                font-size: 12px;
              }
            }
            .el-input {
              height: 30px;
              width: 70%;
            }
            /* input {
              width: 60%;
              height: 30px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(221, 221, 221, 1);
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(187, 187, 187, 1);
              line-height: 17px;
              text-indent: 10px;
            } */
          }
        }
        .form-row:nth-of-type(1) {
          .row-item:nth-of-type(5) {
            width: 28%;
          }
        }
        .form-row:nth-of-type(2) {
          justify-content: flex-end;
        }
      }
      .btn-box {
        display: flex;
        width: 98%;
        justify-content: flex-start;
        height: 70px;
        align-items: center;
        position: absolute;
        top: 120px;
        left: 50%;
        transform: translateX(-50%);
        p {
          width: 88px;
          height: 30px;
          text-align: center;
          line-height: 28px;
          border: 1px solid #02a0ea;
          display: inline-block;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(2, 160, 234, 1);
        }
        p:hover {
          cursor: pointer;
        }
        p:nth-of-type(2) {
          margin-left: 20px;
        }
      }
      .title {
        font-size: 10px;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 14px;
      }
      .itemWrap {
        display: flex;
        justify-content: space-around;
        .item {
          display: flex;
          flex-direction: column;
          text-align: center;
          span {
            font-size: 26px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
          }
          b {
            font-size: 9px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 12px;
          }
        }
        .line {
          width: 1px;
          height: 51px;
          background: #dddddd;
        }
      }
      .el-form {
        .el-button {
          width: 63px;
          height: 21px;
          line-height: 21px;
          text-align: center;
          font-size: 9px;
          padding: 0;
          margin-top: 14px;
          border-radius: 0;
        }
      }
    }
  }
  /deep/.el-table {
    position: absolute;
    top: 141px;
    bottom: 70px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    overflow: auto;
    td {
      padding: 7.5px 0;
    }
    .el-table__header-wrapper {
      position: sticky;
      width: 100%;
      top: 0;
      z-index: 3;
      .el-table__header {
        .has-gutter {
          tr {
            th {
              padding: 8.5px 0;
            }
            th:nth-of-type(1) {
              .cell {
                padding-left: 14px;
              }
            }
          }
        }
      }
    }
  }
  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }
}
</style>